export const NAVBAR_TOOL_BACKGROUND_COLOR = '#c5b6b7';
export const NAVBAR_TOOL_BACKGROUND_IMAGE = "url('/backgrounds/home_rectangle.webp')";

interface NavbarBackgroundTheme {
  backgroundMenuColor: string;
  isToolPage?: boolean;
}

export const resolveNavbarBackground = ({
  backgroundMenuColor,
  isToolPage,
}: NavbarBackgroundTheme) => {
  if (isToolPage) {
    return {
      backgroundColor: NAVBAR_TOOL_BACKGROUND_COLOR,
      backgroundImage: NAVBAR_TOOL_BACKGROUND_IMAGE,
    };
  }

  return {
    backgroundColor: backgroundMenuColor,
    backgroundImage: 'none',
  };
};
